import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { IClientApplicationView, ITalentApplicationView } from '../../Types/Application';
import { ICounterOfferRequest, ICreateOfferRequest } from '../../Types/Offer';
import { AppSettings } from '../../Utils/Settings';

export const offerApi = createApi({
    reducerPath: 'offerApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    endpoints: (builder) => ({     
        createOffer: builder.mutation<any, ICreateOfferRequest>({
            query: (body) => ({
                url: '/offer',
                method: "POST",
                body
            })
        }),   
        counterOffer: builder.mutation<any, {locator: string, body: ICounterOfferRequest}>({
            query: (params) => ({
                url: `/offer/${params.locator}/counter`,
                method: "POST",
                body: params.body
            })
        }),   
    }),
})

export const {
    useCreateOfferMutation,
    useCounterOfferMutation
} = offerApi